import type { TenantModel } from '@/adapters/apiv1.g';
import type { Tenant } from '@/types/core/tenant';
import type { UUID } from '@/utils/uuid';

/**
 * Transform a backend TenantModel to a frontend Tenant type.
 * Handles snake_case to camelCase conversion and provides safe defaults.
 * @param model - API TenantModel response
 * @returns Tenant - UI-friendly Tenant object
 */
export function extractTenant(model: TenantModel): Tenant {
  const withRev = model as TenantModel & { _rev?: number };
  return {
    _rev: withRev._rev,
    id: model.tenant_id as UUID,
    slug: model.slug ?? '',
    name: model.name ?? '',
  };
}
